import * as React from 'react'

import {
  getSensorStateBadgeVariant,
  getSensorStateLabel,
} from '~/client/src/shared/resources/definitions/sensorState'

import { Badge } from '../shadcn-ui/badge'

interface IProps {
  value: unknown
}

export function SensorStateBadge({ value }: IProps) {
  if (value === null || value === undefined || value === '') return null
  return (
    <Badge variant={getSensorStateBadgeVariant(value)}>
      {getSensorStateLabel(value)}
    </Badge>
  )
}
